namespace GeniuzPOS.Inventory {
    export interface IcStockAdjustInDtForm {
        Id: Serenity.IntegerEditor;
        AdjFg: Serenity.IntegerEditor;
        LineItemNo: Serenity.IntegerEditor;
        SkuCode: Serenity.LookupEditor;
        ItemRemark: Serenity.StringEditor;
        UnitChange: Serenity.EnumEditor;
        PurUnit: Serenity.StringEditor;
        Qty: Serenity.DecimalEditor;
        PurUnitRatio: Serenity.DecimalEditor;
        CostValue: Serenity.DecimalEditor;
        PurUnitPrice: Serenity.DecimalEditor;
        UnitCost: Serenity.DecimalEditor;
        Remark: Serenity.StringEditor;
    }

    export class IcStockAdjustInDtForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcStockAdjustInDt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcStockAdjustInDtForm.init)  {
                IcStockAdjustInDtForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;
                var w3 = s.EnumEditor;
                var w4 = s.DecimalEditor;

                Q.initFormType(IcStockAdjustInDtForm, [
                    'Id', w0,
                    'AdjFg', w0,
                    'LineItemNo', w0,
                    'SkuCode', w1,
                    'ItemRemark', w2,
                    'UnitChange', w3,
                    'PurUnit', w2,
                    'Qty', w4,
                    'PurUnitRatio', w4,
                    'CostValue', w4,
                    'PurUnitPrice', w4,
                    'UnitCost', w4,
                    'Remark', w2
                ]);
            }
        }
    }
}
